import {useState} from "react"
import { RequestHistoryView} from "../../../assets/common-svg/CommonSvg";
import {
    Box,
    Button,
    Chip,
    Divider,
    Grid,
    Tooltip,
    Typography,
} from "@mui/material";
import { setOperationTitle } from "../../../store/reducers/operation";
import { useSocketInstance } from "../../../context/SocketContext";
import ConfirmationModal from "../../../components/modal-contents/ConfirmationModal";
import bmrSubjectApi from "../../services/bmrSubjectService";
import { notify } from "../../utils/methods/notification";
import { useDispatch } from "react-redux";
import CustomDrawer from "../../../components/custom-drawer/CustomDrawer";
import HeaderBackNav from "../../../components/header-back-navigation/HeaderBackNav";
import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import { dateFormater } from "../../utils/common/utils";
import moment from "moment";
import { useSelector } from "react-redux";

const RequestHistory = ({SubjectData}) => {
  const { socketInstance } = useSocketInstance();
  const [changeAppliedId, setChangeAppliedId] = useState("");
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyData, setHistoryData] = useState([]);
  const [confimationTitle, setConfimationTitle] = useState("");
  const [openConfirmChangesApplied, setOpenConfirmChangesApplied] = useState(false);
  const LoginData = useSelector((state) => state.loginData);
  const role_id = LoginData?.role_id;

  const dispatch = useDispatch();

    // Using to remove the underScore
    const handleRemoveUnderScore = (value) => {
      return value
        .split("_") // Replace underscores with spaces
        .join(" ")
        .split(" ") // Split into words
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize first letter
        .join(" "); // Join back into a single string
    };

  // handle the confirmation Chnages Applied
  const handleConfirmationChnagesApplied = async (confirmationResult) => {
    if (confirmationResult) {
      const payload = {
        request_reason_id: changeAppliedId,
        confirm: true,
      };
      try {
        const response = await bmrSubjectApi.requestApproval(payload);
        handleGetHistoryData();
         setHistoryOpen(!historyOpen);
        if (response.status == 200) {
          notify.success(response.message)
        }
      } catch (error) {
        notify.error(error?.message || error || "Failed to add appointment")
      } finally {
        setOpenConfirmChangesApplied(false);
      }
    }
    //  else {
    //   console.log("No Choosed")
    // }
  };

    // let PrviousVal;
  const handleGetHistoryData = async () => {
    const payload = {
      subject_id: SubjectData.id,
      phase_id: SubjectData.phase_id,
      page: 1,
      limit: 10,
      feasibility_id:SubjectData?.feasibility_id ? SubjectData?.feasibility_id:''
    };
    try {
      const response = await bmrSubjectApi.requestHistory(
        payload.limit,
        payload.page,
        payload.phase_id,
        payload.subject_id,
        {},
        payload.feasibility_id
      );

      if (response.data.length > 0) {
        setHistoryOpen(!historyOpen);
        setHistoryData(response.data);
      } else {
        notify.error(response.message)
      }
    } catch (error) {
      notify.error(error?.message || error || "Failed to add appointment")
    }
  };

  const handleCloseBar = () =>{
     setHistoryOpen(!historyOpen);
  }     
     // Handle the toggleDrawer for the history viewer:
  const handleHistoryDrawer = () => {
    // setHistoryOpen(!historyOpen);
    handleGetHistoryData();
  };

    const handleRequestApproval = async (id) => {
    setChangeAppliedId(id);
    const payload = { request_reason_id: id };
    try {
      const response = await bmrSubjectApi.requestApproval(payload);
      if (response.status == 200) {
        handleGetHistoryData();
         setHistoryOpen(!historyOpen);
        notify.success(response.message)
      }
      if (response.confirm) {
        if (socketInstance) {
          socketInstance.emit("count_task", null);
        }
        setConfimationTitle(response.message);
        await dispatch(setOperationTitle(null));
        setOpenConfirmChangesApplied(true);
      }
    } catch (error) {
      notify.error(error?.message || error || "Failed to add appointment")
    }
  };

    return (<><Tooltip
        title="Request History"
        onClick={handleHistoryDrawer}
    >
        <button className="cursor-pointer">
            <RequestHistoryView />
        </button>
    </Tooltip>
      {/* Add Custom Drawer for the history viewer */}
       <CustomDrawer open={historyOpen} toggleDrawer={handleHistoryDrawer}>
         <div className="px-6 py-4 w-full">
           <HeaderBackNav
             handleBackNav={handleCloseBar}
             TitleFontSize={"20px"}
             TitleFontWeight={700}
             Title={"Request History"}
           />
         </div>
         <Divider />
 
         <div className="px-6 py-4">
           {historyData?.map((item, index) => (
             <Timeline
               key={index}
               className="!max-w-[40rem]"
               sx={{
                 [`& .${timelineItemClasses.root}:before`]: {
                   flex: 0,
                   padding: 0,
                 },
               }}
             >
               <TimelineItem>
                 <TimelineSeparator>
                   <TimelineDot
                     color={item.status == 1 ? "success" : "warning"}
                   />
                   {index !== historyData.length - 1 && (
                     <TimelineConnector sx={{ bgcolor: "grey.400" }} />
                   )}
                 </TimelineSeparator>
                 <TimelineContent>
                   <Chip
                     size="small"
                     color={item.status == 1 ? "success" : "warning"}
                     label={
                       item.createdAt
                         ? moment(item.createdAt).format("DD/MM/YYYY")
                         : "--"
                     }
                   />
 
                   <div className="bg-gray-50 flex flex-col gap-4 p-4 rounded-lg mt-3 shadow-sm">
                     <div>
                       <Typography variant="h6">
                         {item?.changeRequestReason?.title || "-"}
                       </Typography>
                       <Typography
                         variant="body2"
                         sx={{ color: "text.secondary" }}
                         className="capitalize mt-1"
                       >
                         {item.change_request_reason_value
                           .map((res) => res.title)
                           .join(", ")}
                       </Typography>
                     </div>
 
                     <Typography variant="body1">{item.description}</Typography>
 
                     <Grid container spacing={3}>
                       {/* Previous Value */}
                       <Grid item xs={12} md={6}>
                         <Typography
                           variant="subtitle2"
                           color="text.secondary"
                           gutterBottom
                         >
                           Previous Value
                         </Typography>
                         {item.previous_value ? (
                           <Box className="bg-white p-2 rounded border">
                             {Object.entries(
                               JSON.parse(item.previous_value)
                             ).map(([key, value]) => (
                               <Typography
                                 key={key}
                                 variant="body2"
                                 color="warning.main"
                               >
                                 <strong>{handleRemoveUnderScore(key)}:</strong>{" "}
                                 {moment(value).isValid()
                                   ? dateFormater(value)
                                   : value}
                               </Typography>
                             ))}
                           </Box>
                         ) : (
                           "--"
                         )}
                       </Grid>
 
                       {/* Updated Value */}
                       <Grid item xs={12} md={6}>
                         <Typography
                           variant="subtitle2"
                           color="text.secondary"
                           gutterBottom
                         >
                           New Value
                         </Typography>
                         {item.updated_value ? (
                           <Box className="bg-white p-2 rounded border">
                             {Object.entries(JSON.parse(item.updated_value)).map(
                               ([key, value]) => (
                                 <Typography
                                   key={key}
                                   variant="body2"
                                   color="success.main"
                                 >
                                   <strong>
                                     {handleRemoveUnderScore(key)}:
                                   </strong>{" "}
                                   {moment(value).isValid()
                                     ? dateFormater(value)
                                     : value}
                                 </Typography>
                               )
                             )}
                           </Box>
                         ) : (
                           "--"
                         )}
                       </Grid>
 
                       {/* Resolver Info */}
                       <Grid item xs={12} md={6}>
                         <Typography variant="subtitle2" color="text.secondary">
                           Resolved By
                         </Typography>
                         <Typography variant="body2" className="capitalize">
                           {item.resolver ? item.resolver.name : "--"}
                         </Typography>
                       </Grid>
 
                       <Grid item xs={12} md={6}>
                         <Typography variant="subtitle2" color="text.secondary">
                           Resolved Date
                         </Typography>
                         <Typography variant="body2">
                           {item.resolver
                             ? moment(item.updatedAt).format("DD/MM/YYYY")
                             : "--"}
                         </Typography>
                       </Grid>
                     </Grid>
 
                     {!item.updated_value && role_id === 1 && (
                       <Button
                         variant="contained"
                         size="small"
                         type="button"
                         color="primary"
                         onClick={() => handleRequestApproval(item.id)}
                         sx={{ alignSelf: "start" }}
                       >
                         Change Applied
                       </Button>
                     )}
                   </div>
                 </TimelineContent>
               </TimelineItem>
             </Timeline>
           ))}
         </div>
       </CustomDrawer>
       {/******************seperate this code**********/}
    <ConfirmationModal
         open={openConfirmChangesApplied}
         setOpen={setOpenConfirmChangesApplied}
         errMessage={confimationTitle}
         handleConfirmation={handleConfirmationChnagesApplied}
       />
 </>)
}
export default RequestHistory